import { render, staticRenderFns } from "./ABtn.vue?vue&type=template&id=298a4012&"
import script from "./ABtn.vue?vue&type=script&lang=ts&"
export * from "./ABtn.vue?vue&type=script&lang=ts&"
import style0 from "./ABtn.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports